import FormTitle from '@core/components/FormTitle';
import { DateInput, TextInput } from '@core/components/Inputs';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import SelectMunicipioV2 from 'app/components/Select/SelectMunicipioV2';
import React from 'react';
import CompraDocumentoFiscalInput from '../CompraDocumentoFiscal';
import CompraRetencaoList from './CompraRetencaoList';

const CompraInformacoesNotaFiscal = ({
  id,
  name,
  errors,
  onChange,
  onBlur,
  onAddRetencao,
  onChangeTemRetencao,
  values,
  touched,
  submitCount,
  compraPaga,
  fornecedor,
  compraId,
  categorias,
}) => {
  const _errors = {
    valorBruto: (touched?.valorBruto || submitCount > 0) && errors?.valorBruto,
    municipio: errors?.municipio,
    codigoServicoMunicipal: errors?.codigoServicoMunicipal,
    dataEmissao: (touched?.dataEmissao || submitCount > 0) && errors?.dataEmissao,
  };

  const disabledRetencao =
    compraPaga ||
    categorias?.length > 1 ||
    categorias?.some((categoria) => !categoria.classe?.id || !categoria.valorBruto);

  return (
    <>
      <FormTitle title="Informações da Nota Fiscal" />
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <SelectMunicipioV2
            id={`${id}.municipio`}
            name={`${name}.municipio`}
            label="Município da prestação do serviço"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.municipio}
            touched={_errors?.municipio}
            error={_errors?.municipio}
            disabled={compraPaga}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <TextInput
            id={`${id}.codigoServicoMunicipal`}
            name={`${name}.codigoServicoMunicipal`}
            onChange={onChange}
            onBlur={onBlur}
            value={values?.codigoServicoMunicipal}
            error={_errors.codigoServicoMunicipal}
            touched={touched?.codigoServicoMunicipal}
            required={!!_errors.codigoServicoMunicipal}
            fullWidth
            variant="outlined"
            label="Código de serviço municipal"
            disabled={compraPaga}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <DateInput
            id={`${id}.dataEmissao`}
            name={`${name}.dataEmissao`}
            onChange={onChange}
            onBlur={onBlur}
            value={values?.dataEmissao}
            error={!!_errors.dataEmissao}
            helperText={_errors.dataEmissao}
            touched={touched?.dataEmissao}
            fullWidth
            variant="outlined"
            label="Data de emissão"
            disabled={compraPaga}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextInput
            id={`${id}.serie`}
            name={`${name}.serie`}
            onChange={onChange}
            onBlur={onBlur}
            value={values?.serie}
            error={_errors.serie}
            touched={touched?.serie}
            required={!!_errors.serie}
            maxLength={256}
            fullWidth
            variant="outlined"
            label="Série da NF"
            disabled={compraPaga}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <CompraDocumentoFiscalInput
            id={`${id}.numero`}
            name={`${name}.numero`}
            onChange={onChange}
            onBlur={onBlur}
            value={values?.numero}
            error={_errors.numero}
            fornecedor={fornecedor}
            touched={touched?.numero}
            required={!!_errors.numero}
            label="Documento fiscal"
            disabled={compraPaga}
            compraId={compraId}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <FormControlLabel
            control={
              <Switch
                id={`${id}.temRetencao`}
                name={`${name}.temRetencao`}
                value={values?.temRetencao}
                checked={values?.temRetencao}
                onChange={onChangeTemRetencao}
                onBlur={onBlur}
                color="primary"
                disabled={disabledRetencao}
              />
            }
            label="Retenção"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingTop: 0 }}>
          <CompraRetencaoList
            id={`${id}.retencoes`}
            name={`${name}.retencoes`}
            onChange={onChange}
            onBlur={onBlur}
            values={values?.retencoes}
            errors={errors?.retencoes}
            onAddRetencao={onAddRetencao}
            touched={touched?.retencoes}
            submitCount={submitCount}
            compraPaga={compraPaga}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CompraInformacoesNotaFiscal;
